// extracted by mini-css-extract-plugin
module.exports = {"combined":"Stock_combined__2Vqkq","header":"Stock_header__1x5fP","headerTab":"Stock_headerTab__2vtjO","item":"Stock_item__1n1GG","myButton":"Stock_myButton__3MHIK"};